import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgContractTemplate = function SvgContractTemplate(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24782",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24782)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_66_24782)",
        fillOpacity: 0.16,
        d: "M31.455 66.564q-1.01 0-1.787-.777T28.891 64v-5.897h9.436v-12.25q-3.36.826-6.91-.01-3.551-.837-5.86-3.125V37.5h-4.935l-9.314-9.378q2.87-2.128 6.43-3.535a19.7 19.7 0 0 1 7.313-1.407q3.327 0 6.827 1.112t6.449 3.503v-6.872h32.34v39.52q0 2.576-1.773 4.349-1.772 1.772-4.285 1.772z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24782)",
        d: "M27.455 62.564q-1.01 0-1.787-.777T24.891 60v-5.898h9.436v-12.25q-3.36.828-6.91-.01-3.551-.836-5.86-3.124V33.5h-4.935l-9.314-9.378q2.87-2.13 6.43-3.536a19.7 19.7 0 0 1 7.313-1.407q3.326 0 6.827 1.113t6.449 3.503v-6.872h32.34v39.52q0 2.576-1.773 4.349-1.773 1.772-4.285 1.772zm9.436-8.461h20.16v2.34q0 1.538 1.01 2.547T60.609 60q1.474 0 2.484-1.01t1.01-2.548V19.487H36.89v6.61l18.353 18.352V46.3H53.39L42.763 35.737l-2.25 2.308q-.891.993-1.75 1.564-.86.57-1.872 1.09zM17.782 30.935h6.34v6.583q1.8 1.173 3.432 1.664t3.139.49q2.313 0 4.48-1.06 2.166-1.062 3.551-2.485l2.186-2.243-6.327-6.327q-2.796-2.86-6.257-4.337a18.3 18.3 0 0 0-7.275-1.477q-2.698 0-5.173.798t-4.455 1.97zm36.705 25.73H27.455V60h28.327q-.629-.564-.962-1.46a5.3 5.3 0 0 1-.333-1.873"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24782",
        x1: 11.927,
        x2: 69.84,
        y1: 43.743,
        y2: 43.743,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24782",
        x1: 7.927,
        x2: 65.84,
        y1: 39.743,
        y2: 39.743,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgContractTemplate as ReactComponent };
//# sourceMappingURL=ContractTemplate.svg.es.js.map
